import { render, staticRenderFns } from "./FeedWidget.vue?vue&type=template&id=17a8e606&scoped=true"
import script from "./FeedWidget.vue?vue&type=script&lang=js"
export * from "./FeedWidget.vue?vue&type=script&lang=js"
import style0 from "./FeedWidget.vue?vue&type=style&index=0&id=17a8e606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8e606",
  null
  
)

export default component.exports